import { selectFeatureFlags } from '../../../store/selectors';
import { GlobalState } from '../../../types.global';

const SECOND = 1000;
const MINUTE = SECOND * 60;

export const selectShouldFetch = (state: GlobalState): boolean => {
  const { NEWS_ON } = selectFeatureFlags(state);
  if (!NEWS_ON) return false;

  const { news } = state;

  const now = Date.now();
  return news.lastFetched ? (now - news.lastFetched) > (MINUTE * 5) : true;
};

export const selectNewsData = (state: GlobalState) => {
  const { NEWS_ON } = selectFeatureFlags(state);
  if (!NEWS_ON) return null;

  const { news } = state;
  return news.data;
};
